export const TX_SIGN_CANCELLED_SNACKBAR_TIMEOUT = 7000
export const TX_COMPLETED_SNACKBAR_TIMEOUT = 5000
export const MINIMIZED_SIGN_CANCELLED_SNACKBAR_TIMEOUT = 7000
export const METAPROTOCOL_TX_STATUS_RETRIES_TIMEOUT = 1000
export const METAPROTOCOL_TX_STATUS_RETRIES = 10
export const METAPROTOCOL_SNACKBAR_ID = 'transaction-snackbar'
